<router-outlet></router-outlet>
<grid-ui-routing-component></grid-ui-routing-component>
